import * as React from 'react'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { APP_VERSION } from '../../../config/appVersion'

const linkSX = { mr: 0.5, ml: 0.5 }

const copyRightSx = {
  fontSize: 11,
  m: 0,
  py: 1.5,
  px: 2,
  width: '100%'
}

const CopyRight = ({ sx, ...props }) => (
  <Typography
    variant='body2'
    color='text.secondary'
    align='center'
    sx={[copyRightSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
    {...props}
  >
    {`v${APP_VERSION}`}
    {' · '}
    Copyright ©
    <Link color='inherit' href='https://worldsafesystem.com/' sx={linkSX}>
      World Safe System
    </Link>
    {` ${new Date().getFullYear()}`}
  </Typography>
)

export default CopyRight
